// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__Am1sf","active":"Breadcrumb_active__mA-Ls"};